import { useState, useCallback } from 'react';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

export interface Toast {
  id: string;
  message: string;
  description?: string;
  type: ToastType;
}

export function useToast() {
  const [toasts, setToasts] = useState<Toast[]>([]);

  const addToast = useCallback((message: string, type: ToastType = 'info', description?: string) => {
    const id = Math.random().toString(36).slice(2);
    setToasts(prev => [...prev, { id, message, description, type }]);
    setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== id));
    }, 4000);
  }, []);

  const removeToast = useCallback((id: string) => {
    setToasts(prev => prev.filter(t => t.id !== id));
  }, []);

  const success = useCallback((message: string, description?: string) => addToast(message, 'success', description), [addToast]);
  const error = useCallback((message: string, description?: string) => addToast(message, 'error', description), [addToast]);
  const warning = useCallback((message: string, description?: string) => addToast(message, 'warning', description), [addToast]);
  const info = useCallback((message: string, description?: string) => addToast(message, 'info', description), [addToast]);

  return { toasts, removeToast, success, error, warning, info };
}
